import { startsWith } from 'lodash';
import { map } from '@lendi-ui/breakpoint';
import { css } from 'styled-components';

var display = val => map(val, v => v && "display: ".concat(v, ";"));
/**
 * Derive size from root CSS variable
 * @param multiplier
 */

var deriveSize = multiplier => {
  if (multiplier === 1) {
    return "var(--lendi-ui-size)";
  }

  return "calc(".concat(multiplier, " * var(--lendi-ui-size))");
};
var normalise = css(["box-sizing:border-box;line-height:1.333;white-space:normal;border-spacing:2px;text-align:left;word-spacing:normal;letter-spacing:normal;"]);
var NORMALISE_LINE_HEIGHT = 1.333;

/**
 * return all the props of an object where the key begins with 'data-'
 * @param props The props object of a given component
 */
var getDataProps = props => {
  var dataProps = {};

  for (var _key in props) {
    if (startsWith(_key, 'data-')) {
      dataProps[_key] = props[_key];
    }
  }

  return dataProps;
};

export { NORMALISE_LINE_HEIGHT, deriveSize, display, getDataProps, normalise };
